import React, { ReactElement } from 'react';
import './ErrorsLayout.style.scss';

interface IProps {
  children: ReactElement | ReactElement[];
}

const ErrorsLayout = ({ children }: IProps) => {
  return (
    <div className="errorsLayout">
      <div>{children}</div>
    </div>
  );
};

export default ErrorsLayout;
